import type { ChangelogTab } from "features/types/tabs";
import { Box } from "prism-react";
import { useRef } from "react";

import { DevtoolWrapper } from "./common/DevtoolWrapper";
import type { TabPanelProps } from "./types";

export const ChangelogDevtool: React.FC<TabPanelProps<ChangelogTab>> = () => {
  const baseUrl = `https://codesandbox.io/changelog?headless=1`;

  const iframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <DevtoolWrapper variant="file">
      <Box
        css={{
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <iframe
          ref={iframeRef}
          src={baseUrl}
          style={{
            border: 0,
            width: "100%",
            height: "100%",
          }}
          title="changelog"
        />
      </Box>
    </DevtoolWrapper>
  );
};
